import { render, staticRenderFns } from "./reset-password-page.vue?vue&type=template&id=58c4a509&scoped=true&"
import script from "./reset-password-page.vue?vue&type=script&lang=js&"
export * from "./reset-password-page.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-page.vue?vue&type=style&index=0&id=58c4a509&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4a509",
  null
  
)

export default component.exports